import React, { useState, useEffect } from "react";
import { NumericFormat } from 'react-number-format';
import { Link } from "react-router-dom";
import axios from "axios";
import ReactPaginate from 'react-paginate';

function ProductList() {
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [keywordname, setKeywordName] = useState("");
  const [queryname, setQueryName] = useState("");
  const [keywordmanu, setKeywordManu] = useState("");
  const [querymanu, setQueryManu] = useState("");
  const [msg, setMsg] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    getProducts();
  }, [page, keywordname, keywordmanu]);

  const getProducts = async () => {
    const response = await axios.get(
      `${API_BASE_URL}/products?search_name=${keywordname}&search_manufacture=${keywordmanu}&page=${page}&limit=${limit}`, {
        headers: {
            'X-API-Key': API_KEY
        },
      }
    );
    setProducts(response.data.result);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const changePage = ({ selected }) => {
    setPage(selected);
    if (selected === 9) {
      setMsg(
        "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
      );
    } else {
      setMsg("");
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeywordName(queryname);
    setKeywordManu(querymanu);
  };

  const deleteProduct = async (productId) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      await axios.delete(`${API_BASE_URL}/products/${productId}`);
      getProducts();
    } else {
      return
    }  
  };

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-centered">
          <h1 className="title is-size-5">Data Products</h1>         
            <Link to="/products/add" className="button is-small is-primary mb-2">
              Add New Product
            </Link>           
            <div className="columns">
            <div className="column is-6">
              <form onSubmit={searchData}>
                <div className="field has-addons">
                  <div className="control is-expanded">
                    <input
                      type="text"
                      className="input is-small"
                      value={queryname}
                      onChange={(e) => setQueryName(e.target.value)}
                      placeholder="Search by product name..." />
                  </div>
                  <div className="control is-expanded">
                    <input
                      type="text"
                      className="input is-small"
                      value={querymanu}
                      onChange={(e) => setQueryManu(e.target.value)}
                      placeholder="Search by manufacturer..." />
                  </div>
                  <div className="control">
                    <button type="submit" className="button is-small is-info">
                      Search
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="table-container">
        <table className="table is-striped is-fullwidth is-size-7">
          <thead>
            <tr>
              <th>No</th>
              <th className="has-text-centered">Actions</th>
              <th>Image</th>
              <th>Product_Name</th>
              <th>Price</th>
              <th>Part_Number</th>
              <th>Serial_Number</th>
              <th>Manufacturer</th>
              <th>Category</th>
              <th>Stock</th>
              <th>Last_Update</th>
              <th>Created_By</th>                
            </tr>
          </thead>
          <tbody>
            {products.map((product, index) => (
              <tr key={product.uuid}>
                <td>{index + 1}</td>
                <td className="has-text-centered">
                  <div className="is-inline-flex">
                    <Link
                      to={`/products/edit/${product.uuid}`}
                      className="button is-small is-info mr-1"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => deleteProduct(product.uuid)}
                      className="button is-small is-danger"
                    >
                      Delete
                    </button>
                  </div>
                </td>
                <td>
                  <figure className="image is-4by3">
                    <img src={product.url} alt="Image" />
                  </figure>
                </td>
                <td>{product.name}</td>
                <td className="has-text-right">
                  <NumericFormat
                    value={product.price}
                    displayType="text" // Renders as a <span> instead of an input
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true} />
                </td>
                <td>{product.partnumber}</td>
                <td>{product.serialnumber}</td>
                <td>{product.manufacturer}</td>
                <td>{product.category.name}</td>
                <td className="has-text-right">
                  <NumericFormat
                    value={product.stock.in_stock}
                    displayType="text" // Renders as a <span> instead of an input
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true} />                    
                </td>
                <td>
                  {new Date(product.stock.last_update_time).toLocaleDateString('id', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false,
                  })}                    
                  </td>
                <td>{product.user.name}</td>
                
              </tr>
            ))}
          </tbody>
        </table>
        <p className="is-size-7">
          Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
        </p>
        <p className="has-text-centered has-text-danger">{msg}</p>
        <nav
          className="pagination is-centered is-size-7"
          key={rows}
          role="navigation"
          aria-label="pagination"
        >
          <ReactPaginate
            breakLabel="..."
            previousLabel={"< Prev"}
            nextLabel={"Next >"}
            pageCount={Math.min(10, pages)}
            onPageChange={changePage}
            containerClassName={"pagination-list"}
            pageLinkClassName={"pagination-link"}
            previousLinkClassName={"pagination-previous"}
            nextLinkClassName={"pagination-next"}
            activeLinkClassName={"pagination-link is-current"}
            disabledLinkClassName={"pagination-link is-disabled"} />
        </nav>
      </div>
    </div>
  );
}

export default ProductList;
